import { useCallback } from "react";
import { useApiBase } from '../base/api-baixas-base'

export const useGetLoginContato = () => {
    const { invocarApi, ...props } = useApiBase();

    const getLoginContato = useCallback(
        (email: string, telefone: string) => {

            let queryFinal = email.length !== 0  || telefone.length !== 0 ? `?email=${email}&telefone=${telefone}` : '';
            return invocarApi({
                url: `v1/Operacao/contato${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: false,
            })
        },
        [invocarApi],
    )
    return {
        getLoginContato,
        ...props
    }
}
